// extracted by mini-css-extract-plugin
export default {"icon":"Bvf4SR","more":"_EA3Ke","actions":"Z9ijf3"};